
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syncs/cdc",
      function () {
        return require("private-next-pages/syncs/cdc.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syncs/cdc"])
      });
    }
  